var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"src":_vm.logo,"height":_vm.height ? _vm.height : '100%',"contain":""}})}
var staticRenderFns = []

export { render, staticRenderFns }